import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../../context/SiteContext';

export default function Footer() {
  const { settings } = useSite();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link to="/" className="brand" aria-label="Thế Thảo Pharma — Chung tay vì một cuộc sống khoẻ đẹp" onClick={scrollToTop}>
            <img src="/assets/img/logo-icon-white.svg" alt="" className="brand__icon" width="64" height="64" />
            <span className="brand__text">
              <span className="brand__name">THẾ THẢO PHARMA</span>
              <span className="brand__tagline">Chung tay vì một cuộc sống khoẻ đẹp</span>
            </span>
          </Link>
          <p>
            Công ty Cổ phần Thế Thảo Pharma — Nhà phân phối dược mỹ phẩm, thực phẩm chức năng &amp; thiết bị y tế chuyên kênh OTC.
          </p>
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2v-3h2V9.5C10.4 7.4 11.7 6 13.7 6c.6 0 1.3.1 1.9.2v2.4h-1.2c-1.2 0-1.5.6-1.5 1.5V12h2.6l-.4 3h-2.2v7A10 10 0 0 0 22 12z" />
              </svg>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23 7a3 3 0 0 0-2.1-2.1C19 4.5 12 4.5 12 4.5s-7 0-8.9.4A3 3 0 0 0 1 7 31 31 0 0 0 .5 12 31 31 0 0 0 1 17a3 3 0 0 0 2.1 2.1C5 19.5 12 19.5 12 19.5s7 0 8.9-.4A3 3 0 0 0 23 17a31 31 0 0 0 .5-5 31 31 0 0 0-.5-5zM10 15V9l5.2 3z" />
              </svg>
            </a>
            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M16.6 5.8c-.6-.7-.9-1.5-.9-2.4V3h-3.1v12.4c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5c.3 0 .5 0 .8.1V9.8c-.3 0-.5-.1-.8-.1A5.5 5.5 0 1 0 14.7 19V9.8c.9.6 2 .9 3.1.9V7.6c-.4 0-.8-.1-1.2-.3z" />
              </svg>
            </a>
            <a href="https://zalo.me" target="_blank" rel="noopener noreferrer" aria-label="Zalo">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="12" r="10" />
                <text x="12" y="15" textAnchor="middle" fill="#005b31" fontSize="7" fontWeight="800" fontFamily="sans-serif">
                  Zalo
                </text>
              </svg>
            </a>
          </div>
        </div>

        <div>
          <h4>Khám phá</h4>
          <ul>
            <li><Link to="/" onClick={scrollToTop}>Trang chủ</Link></li>
            <li><Link to="/gioi-thieu" onClick={scrollToTop}>Giới thiệu</Link></li>
            <li><Link to="/tin-tuc" onClick={scrollToTop}>Tin tức &amp; sự kiện</Link></li>
            <li><Link to="/tuyen-dung" onClick={scrollToTop}>Tuyển dụng</Link></li>
          </ul>
        </div>

        <div>
          <h4>Cộng đồng</h4>
          <ul>
            <li><strong>Dự án:</strong> <Link to="/tu-thuoc-cho-em" onClick={scrollToTop}>Tủ Thuốc Cho Em</Link></li>
            <li><strong>Group:</strong> <a href="https://www.facebook.com/groups/934460299578977" target="_blank" rel="noopener noreferrer">Hội Nhà thuốc và Dược sĩ 5.0</a></li>
          </ul>
        </div>

        <div>
          <h4>Liên hệ</h4>
          <ul>
            <li>
              <strong>Địa chỉ văn phòng:</strong>
              <br />
              <span>{settings.contact_address}</span>
            </li>
            <li>
              <strong>Email:</strong>{' '}
              <a href={`mailto:${settings.contact_email}`}>{settings.contact_email}</a>
            </li>
            <li>
              <strong>Hotline CSKH:</strong>{' '}
              <a href={`tel:${settings.contact_phone_cskh}`}>{settings.contact_phone_cskh}</a>
            </li>
            <li>
              <strong>Hotline HR:</strong>{' '}
              <a href={`tel:${settings.contact_phone_hr}`}>{settings.contact_phone_hr}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container footer-bottom">
        <div>© 2026 Công ty Cổ phần Thế Thảo Pharma.</div>
        <div>Đồng hành vững vàng — Nhà thuốc vươn xa.</div>
      </div>
    </footer>
  );
}
